export default __webpack_public_path__ + "static/bird-836b0f13be8545c614fa249cb2e5fc4b.webp";